/**
 * OWNED BY C5. Plain-language install copy (F-703).
 *
 * The iOS text has to earn its keep: on iOS, a site that is not installed can have its
 * storage wiped by Safari after 7 days without a visit, which on this app means the
 * day's un-synced sales. Say that in words a market trader reads once and acts on.
 *
 * Kept as data (not JSX) so C1 owns all rendering and so the strings are testable.
 */

export interface InstallCopy {
  /** Short line for a banner. */
  title: string;
  /** One or two sentences explaining why. */
  body: string;
  /** Ordered steps, already in tap order. */
  steps: string[];
  /** Label for the primary button. On Android this triggers `promptInstall()`. */
  cta: string;
  /** Label for the dismiss button. */
  dismiss: string;
}

export const IOS_INSTALL_COPY: InstallCopy = {
  title: "Add WebCashier to your Home Screen",
  body:
    "On iPhone and iPad, Safari deletes a website's saved data after 7 days without a visit. " +
    "If that happens before your sales have synced, they are gone. Adding WebCashier to your Home Screen keeps your register, products and sales safe, and it opens full screen.",
  steps: [
    "Tap the Share button at the bottom of Safari (the square with an arrow).",
    "Scroll down and tap “Add to Home Screen”.",
    "Tap “Add”, then open WebCashier from your Home Screen from now on.",
  ],
  cta: "Show me how",
  dismiss: "Not now",
};

export const ANDROID_INSTALL_COPY: InstallCopy = {
  title: "Install WebCashier",
  body:
    "Installing keeps the app one tap away, opens it full screen without the browser bars, and keeps your sales stored safely on this device while you are offline.",
  steps: ["Tap Install.", "Confirm in the Android prompt.", "Open WebCashier from your home screen from now on."],
  cta: "Install",
  dismiss: "Not now",
};

/** Shown next to the storage badge when the browser refused persistent storage. */
export const STORAGE_NOT_PERSISTED_COPY =
  "This browser has not promised to keep WebCashier's data. Sales are still saved on this device and synced when you are online, but install the app and sign in regularly to be safe.";

export function installCopyFor(hint: "android" | "ios" | null): InstallCopy | null {
  if (hint === "ios") return IOS_INSTALL_COPY;
  if (hint === "android") return ANDROID_INSTALL_COPY;
  return null;
}

/** F-703: stop nagging after three dismissals. */
export const MAX_INSTALL_DISMISSALS = 3;
